/**
 * @generated SignedSource<<a06a8a013af654ab7c26aeab2b65cf59>>
 * @relayHash 32571b6f378434b18a3f7ffd275bf6d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7b9659f35a7eec8367641693f458f5b2681600dc7f00ef95a9271421a2154a8c

import type { ConcreteRequest } from 'relay-runtime';
export type SendTrackViewPageEventQuery$variables = {
  contentId?: string | null;
};
export type SendTrackViewPageEventQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly history: {
        readonly createdDate: string | null;
        readonly lastUpdated: {
          readonly when: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly metadata: {
        readonly frontend: {
          readonly fabricEditorEligibility: string | null;
          readonly fabricEditorSupported: boolean | null;
        } | null;
      };
      readonly space: {
        readonly id: string | null;
      } | null;
      readonly status: string | null;
    } | null> | null;
  } | null;
};
export type SendTrackViewPageEventQuery = {
  response: SendTrackViewPageEventQuery$data;
  variables: SendTrackViewPageEventQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "createdDate"
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "lastUpdated",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "when"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "fabricEditorSupported"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "fabricEditorEligibility"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "status"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SendTrackViewPageEventQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendTrackViewPageEventQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "32571b6f378434b18a3f7ffd275bf6d4",
    "id": "7b9659f35a7eec8367641693f458f5b2681600dc7f00ef95a9271421a2154a8c",
    "metadata": {},
    "name": "SendTrackViewPageEventQuery",
    "operationKind": "query",
    "text": "query SendTrackViewPageEventQuery($contentId:ID){content(id:$contentId){nodes{id,history{createdDate,lastUpdated{when}},metadata{frontend{fabricEditorSupported,fabricEditorEligibility}},space{id},status}}}"
  }
};
})();

(node as any).hash = "19847917790449aae265767493366eb2";

export default node;
